import { AuthStore } from "./AuthStore";
import { CustomerStore } from "./CustomerStore";
import { GoalStore } from "./GoalStore";
import { GroupStore } from "./GroupStore";
import { TaskStore } from "./TaskStore";
import { UserStore } from "./UserStore";
import { FilterStore } from "./FilterStore";
import { SelfTrackingStore } from "./SelfTrackingStore";
import { TariffGroupingStore } from "./TariffGroupingStore";

export class RootStore {
  authStore: AuthStore;
  userStore: UserStore;
  customerStore: CustomerStore;
  groupStore: GroupStore;
  goalStore: GoalStore;
  taskStore: TaskStore;
  filterStore: FilterStore;
  selfTrackingStore: SelfTrackingStore;
  tariffGroupingStore: TariffGroupingStore;

  constructor() {
    this.authStore = new AuthStore(this);
    this.userStore = new UserStore(this);
    this.customerStore = new CustomerStore(this);
    this.groupStore = new GroupStore(this);
    this.goalStore = new GoalStore(this);
    this.taskStore = new TaskStore(this);
    this.filterStore = new FilterStore(this);
    this.selfTrackingStore = new SelfTrackingStore(this);
    this.tariffGroupingStore = new TariffGroupingStore(this);
  }
}

export const rootStore = new RootStore();
